import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var CarouselIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    as: "rect",
    x: "2",
    y: "13",
    width: "6.6",
    height: "22",
    rx: "2.5"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    as: "rect",
    x: "13",
    y: "8.6001",
    width: "22",
    height: "30.8",
    rx: "2.5"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M39.3999 15.5C39.3999 14.1193 40.5192 13 41.8999 13H43.4999C44.8806 13 45.9999 14.1193 45.9999 15.5V32.5C45.9999 33.8807 44.8806 35 43.4999 35H41.8999C40.5192 35 39.3999 33.8807 39.3999 32.5V15.5Z"
  }));
});
CarouselIcon.displayName = 'CarouselIcon';
CarouselIcon.defaultProps = {
  'aria-label': 'Carousel'
};
export default CarouselIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/CarouselIcon/index.js
// module id = 1978
// module chunks = 12